import React from "react";
import { useCanScanQr, useQrScanner } from "./QrScannerProvider";

// "Scan QR" entry point, used by every workflow. Without `onAsset` it is the
// global scanner (opens Asset 360). With `onAsset` the scanned/looked-up
// asset context is handed to the calling workflow instead. `publicRequest`
// (the unauthenticated fault portal) supplies its own resolvers and skips the
// signed-in permission check - it can only ever select an asset for a report.
export default function ScanQrButton({
    className = "btn btn-light-primary btn-sm mr-3",
    label = "Scan QR",
    title,
    onAsset,
    requires,
    publicRequest
}) {
    const { openQrScanner } = useQrScanner();
    const canScan = useCanScanQr(requires);
    if ((!publicRequest && !canScan) || !openQrScanner) return null;

    return (
        <button
            type="button"
            className={className}
            onClick={() => openQrScanner({ title, onAsset, ...(publicRequest || {}) })}
            title="Scan an asset QR code"
        >
            <i className="fas fa-qrcode mr-2" aria-hidden="true"></i>
            {label}
        </button>
    );
}
